<template>

    <div
        class="announcement"
        v-html="announcement"
    />

</template>

<script>

export default {

    props: {
        announcement: {
            required:true,
            type:String,
        },
    },

}

</script>
